<template>
    <div>
        <div class="seachBox flex">
            <div class="seachList"><span class="name">更新日期：</span>
                <a-range-picker class="seachs" v-model="seach.update_time"   :showTime="false" :allowClear="false"    format="YYYY-MM-DD"  />
            </div>
            <div class="seachList"><span class="name">关键字：</span>
                <a-input placeholder="" class="seachs" v-model="seach.name"/>
            </div>
            <div class="seachList  ">
                <a-button type="primary" size="default" class="seachBtn" @click="getList(1)" style="margin-right: 15px">
                    查询
                </a-button>
                <a-button size="default" class="seachBtn" @click="resetSeach()">重置</a-button>
            </div>
            <div class="seachList no"></div>
            <div class="seachList no"></div>
        </div>

        <div >
            <a-button class="top_btn" type="primary" @click="add('')" v-has="'btn_add'" > 添加新闻 </a-button>
            <a-button class="top_btn" type="primary" :disabled="!hasSelected" :loading="loading"
                      @click="editLanguage('status','1')" v-has="'btn_unrelease'">
                发布
            </a-button>
            <a-button class="top_btn" type="primary" :disabled="!hasSelected" :loading="loading"
                      @click="editLanguage('status','0')" v-has="'btn_unrelease'">
                取消发布
            </a-button>
            <a-button class="top_btn" type="primary" :disabled="!hasSelected" :loading="loading"
                      @click="editLanguage('is_top','1')" v-has="'btn_unplacement'">
                置顶
            </a-button>
            <a-button class="top_btn" type="primary" :disabled="!hasSelected" :loading="loading"
                      @click="editLanguage('is_top','0')" v-has="'btn_unplacement'">
                取消置顶
            </a-button>
            <a-popconfirm
                    title="此操作将永久删除, 是否继续?"
                    ok-text="确定"
                    cancel-text="取消"
                    @confirm="editLanguage('5')"
                    @cancel="()=>{}"
                    :disabled="!hasSelected"
            >
                <a-button   type="primary" :disabled="!hasSelected" :loading="loading"  v-has="'btn_delete'">
                    删除
                </a-button>
            </a-popconfirm>

            <span style="margin-left: 8px">
        <template v-if="hasSelected">
          {{ `选中 ${selectedRowKeys.length} 项` }}
        </template>
      </span>
        </div>
        <a-table :columns="columns" :data-source="data" :loading="loading" :pagination="pagination" rowKey="id"
                 :row-selection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }">
            <span slot="status" slot-scope="text, record">
         <a-switch   @click="onChange(record,'status')"
                   :checked="text==1?true:false" :disabled="!$_has('btn_unrelease')"/>
            </span>
            <span slot="is_top" slot-scope="text, record">
         <a-switch   @click="onChange(record)"
                   :checked="text==1?true:false"  :disabled="!$_has('btn_unplacement')"/>
            </span>
            <span slot="action" slot-scope="text, record">
                <i v-if="$_hasAll(['btn_edit','btn_delete'])" style="color:#838383">暂无操作权限</i>
            <a  v-has="'btn_edit'" @click="add(text.id ) " >编辑<a-divider type="vertical"/></a>
          <a-popconfirm
                  title="此操作将永久删除, 是否继续?"
                  ok-text="确定"
                  cancel-text="取消"
                  @confirm="confirm([record.id])"
                  @cancel="()=>{}"
          >
   <a v-has="'btn_delete'">删除</a>
  </a-popconfirm>
      </span>
        </a-table>
    </div>
</template>

<script>
    import API from "./api";
    import moment from 'moment';
    import {changStatus, removeById,orderList} from "../../utils/utils"
    const columns = [
        {
            title: "标题",
            dataIndex: "name",
            ellipsis: true,
            key: "name",
        },
        {
            title: "发布时间",
            dataIndex: "release_time",
            ellipsis: true,
            key: "release_time"
        },
        {
            title: "更新时间",
            dataIndex: "update_time",
            ellipsis: true,
            key: "update_time",
        },
        {
            title: "发布",
            key: "status",
            width: "150px",
            dataIndex: "status",
            scopedSlots: {customRender: "status"}
        },
        {
            title: "置顶",
            key: "is_top",
            width: "150px",
            dataIndex: "is_top",
            scopedSlots: {customRender: "is_top"}
        },

        {
            title: "操作",
            key: "action",
            width: "150px",
            scopedSlots: {customRender: "action"}
        }
    ];
    export default {
        name: "index",
        data() {
            return {
                resetSeachdata:true,
                visibleImg: false,
                tableImg: "",
                seach: {
                    name: "",
                    update_time: [],
                },
                pagination: {
                    pageNo: 1,
                    pageSize: 20, // 默认每页显示数量
                    onShowSizeChange: (pageSize) => (this.pageSize = pageSize), // 改变每页数量时更新显示
                    onChange: this.getList.bind(this), //点击页码事件
                    total: 0, //总条数
                    current: 0,
                    size: "small",
                    showTotal: total => `共 ${total} 条`,
                    showQuickJumper: true
                },
                data: [],
                columns,
                selectedRowKeys: [], // Check here to configure the default column
                loading: true,
            }
        },
        created() {
            this.$store.state.adminleftnavnum = "/NewsManagement/NewsManagementList"; //设置左侧导航2-2 active
        },
        mounted() {
            this.getList()
        },
        computed: {
            hasSelected() {
                return this.selectedRowKeys.length > 0;
            },
        },
        methods: {
            add(id) {
                if (id == '') {
                    this.$router.push('/NewsManagement/AddNewsManagement')
                } else {
                    this.$router.push(`/NewsManagement/EditNewsManagement?id=${id}`)
                }

            },
            confirm(id) {
                removeById(API.service.DELE,id).then(res => {
                    if (res == true) {
                        this.getList()
                        this.selectedRowKeys=[]
                    }
                })
            },

            onChange(row,type) {
            this.loading=true
                let Json = type=="status"?{id: row.id, status: row.status == 0 ? 1 : 0}:{id: row.id, is_top: row.is_top == 0 ? 1 : 0}
                // let Json = {id: row.id, status: row.status == 0 ? 1 : 0}
                if(type=="status"){
                    let Json =  {id: row.id, status: row.status == 0 ? 1 : 0}
                    changStatus(API.service.CHANG_STATUS, [Json]).then(res => {
                        if (res == true) {
                            this.getList()
                        }
                    })
                }else{
                    let Json ={id: row.id, is_top: row.is_top == 0 ? 1 : 0}
                    changStatus(API.service.CHANG_TOP, [Json]).then(res => {
                        if (res == true) {
                            this.getList()
                        }
                    })
                }


            },
            resetSeach() {
                this.loading = true
                this.seach = {
                    name: "",
                    update_time:this.seach.update_time.length>0?[moment(new Date(), 'YYYY-MM-DD'), moment(new Date(), 'YYYY-MM-DD')]:[],
                }
                this.resetSeachdata=false
                this.getList(1)
            },
            getList(page) {
                let seachData=JSON.parse(JSON.stringify(this.seach))
                if (seachData.update_time.length > 0&&this.resetSeachdata==true) {
                    seachData.update_time[0] = moment(this.seach.update_time[0]).format('YYYY-MM-DD')
                    seachData.update_time[1] = moment(this.seach.update_time[1]).format('YYYY-MM-DD')
                }else{
                    seachData.update_time=[]
                }

                API.service.GET_LIST({page: page || 1, ...seachData}).then(res => {
                    this.data = res.data.data.data
                    this.pagination.total = res.data.data.total
                    this.pagination.pageSize = res.data.data.per_page
                    this.pagination.current = res.data.data.current_page
                    if(!this.resetSeachdata==true)this.seach.update_time=[]
                    this.selectedRowKeys=[]
                    this.resetSeachdata=true
                    this.loading = false
                })
            },
            onSelectChange(selectedRowKeys) {
                this.selectedRowKeys = selectedRowKeys;
            },
            editLanguage(name, type) {
                if (name == '5') {
                    this.confirm(this.selectedRowKeys)
                }
                let url
                let dataArr = []
                let dataJson = {}
                this.selectedRowKeys.map((item, index) => {
                    dataJson = {}
                    dataJson.id = item;
                    dataJson[name] = type;
                    dataArr.push(dataJson)
                })
                if (name == 'is_top') {
                    changStatus(API.service.CHANG_TOP,dataArr).then(res => {
                        if (res == true) {
                            this.getList()
                        }
                    })
                }
                if (name == 'status') {
                    changStatus(API.service.CHANG_STATUS,dataArr).then(res => {
                        if (res == true) {
                            this.getList()
                        }
                    })
                }
            },
        }
    }
</script>

<style scoped>
    .seachBox .seachList .name {
        width: 70px !important;
    }

    .seachBox .seachList .seachs {
        width: calc(100% - 80px);
    }
    .seachBox .seachList .seachs.white >>> .ant-input{color: #fff!important;}
    .seachBox .seachList .seachs.white >>> .ant-calendar-range-picker-separator{color: #fff!important;}

</style>
